<section
  class="ui-sticky-action-bar"
  [class.ui-sticky-action-bar-elevated]="elevated()"
  [class.ui-sticky-action-bar-start]="isStart()"
  [class.ui-sticky-action-bar-center]="isCenter()"
  [class.ui-sticky-action-bar-end]="isEnd()"
  [class.ui-sticky-action-bar-stretch]="isStretch()"
  [attr.aria-label]="ariaLabel()"
>
  <ng-content />
</section>
